import { render, staticRenderFns } from "./StaffActivePageTableControl.vue?vue&type=template&id=43337e0b&scoped=true&"
import script from "./StaffActivePageTableControl.vue?vue&type=script&lang=js&"
export * from "./StaffActivePageTableControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43337e0b",
  null
  
)

export default component.exports